var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6FB643;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,20.9c0,0,0-6.5,6.5-6.5h19.5c0,0,0,6.5-6.5,6.5H23.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,29.2c0,0,0-6.5,6.5-6.5h9.7c0,0,0,6.5-6.5,6.5H23.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,37.5c0,0,0-6.5,6.5-6.5h3.2c0,0,0,6.5-6.5,6.5H23.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,32.5v5.2H0.4l13.5-18.4H2.3v-5.2h21.8L10.7,32.5H21.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZend);
export default __webpack_public_path__ + "static/media/zend.1de6f8097433cb5eee3a5a2a2b9a4b2e.svg";
export { ForwardRef as ReactComponent };